import type { MantineTheme } from '@mantine/core';
import { createStyles } from '@mantine/core';

interface BorderRadius {
	borderTopLeftRadius: string;
	borderTopRightRadius: string;
	borderBottomLeftRadius: string;
	borderBottomRightRadius: string;
}

interface WrapperBorderRadiusParams {
	theme: MantineTheme;
	isFirst: boolean;
	isLast: boolean;
	isChild: boolean;
	hasImpactedEntities: boolean;
	hasNextPage: boolean;
	opened: boolean;
}

function getWrapperBorderRadius({
	theme,
	isFirst,
	isLast,
	isChild,
	hasImpactedEntities,
	hasNextPage,
	opened,
}: WrapperBorderRadiusParams): BorderRadius {
	let borderRadius: BorderRadius = {
		borderTopLeftRadius: 'unset',
		borderTopRightRadius: 'unset',
		borderBottomLeftRadius: 'unset',
		borderBottomRightRadius: 'unset',
	};

	if (isFirst && !isChild) {
		borderRadius = {
			...borderRadius,
			borderTopLeftRadius: theme.radius.md,
			borderTopRightRadius: theme.radius.md,
		};
		if (!hasImpactedEntities || !opened) {
			borderRadius = {
				...borderRadius,
				borderBottomLeftRadius: theme.radius.md,
				borderBottomRightRadius: theme.radius.md,
			};
		}
	}

	if (isLast) {
		borderRadius = {
			...borderRadius,
			borderBottomLeftRadius: hasNextPage ? 'unset' : theme.radius.md,
			borderBottomRightRadius: hasNextPage ? 'unset' : theme.radius.md,
		};
	}

	return borderRadius;
}

export const useStyles = createStyles(
	(
		theme,
		{
			isHovered,
			isFirst,
			isLast,
			isChild,
			hasImpactedEntities,
			hasNextPage,
			opened,
		}: {
			isHovered: boolean;
			isFirst: boolean;
			isLast: boolean;
			isChild: boolean;
			hasImpactedEntities: boolean;
			hasNextPage: boolean;
			opened: boolean;
		}
	) => {
		const wrapperBorderRadius = getWrapperBorderRadius({
			theme,
			isFirst,
			isLast,
			isChild,
			hasImpactedEntities,
			hasNextPage,
			opened,
		});

		return {
			wrapper: {
				backgroundColor: isHovered
					? theme.other.getColor('surface/primary/hover')
					: theme.other.getColor('surface/primary/default'),

				...wrapperBorderRadius,
			},
			cardWrapper: {
				width: '100%',
				borderTopLeftRadius: theme.radius.md,
				borderTopRightRadius: theme.radius.md,
				borderBottomLeftRadius: opened ? 0 : theme.radius.md,
				borderBottomRightRadius: opened ? 0 : theme.radius.md,
				'&:hover': {
					backgroundColor: theme.other.getColor('surface/primary/hover'),
				},
			},
			titleWrapper: {
				width: 460,
				flexGrow: 1,
			},
			chevronWrapper: {
				minWidth: `calc(${theme.other.iconSize.md}px + ${theme.spacing.xs})`, // Size of icon + right padding
			},
		};
	}
);
